export class GateDError extends Error {
  constructor(code, message = code, status = 400, details = undefined) {
    super(message);
    this.name = 'GateDError';
    this.code = code;
    this.status = status;
    this.details = details;
  }
}

export const gateDError = (code, status = 400, details, message = code) => (
  new GateDError(code, message, status, details)
);

export function asGateDError(error) {
  if (error instanceof GateDError) return error;
  return new GateDError('GATE_D_INTERNAL_ERROR', 'The request could not be completed.', 500);
}
